export default __webpack_public_path__ + "static/media/caleb-icon.ada4179c.svg";